import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import DesignerCard from '../DesignerCard/DesignerCard';
import Loader from '../Loader/Loader';
import arabicImages from '../../assets/images/arabicImages';
import './ArabicGrid.css';

const FALLBACK_IMG = 'https://via.placeholder.com/150?text=ARAB';

const ArabicGrid = ({ onSelectDesigner }) => {
  const [arabicHouses, setArabicHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const normalize = (s) =>
    String(s || '')
      .toLowerCase()
      .trim()
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ');

  const getLogo = (designerRaw) => {
    const keySpace = normalize(designerRaw);
    const keyDash = keySpace.replace(/\s+/g, '-');
    return arabicImages[keySpace] || arabicImages[keyDash] || FALLBACK_IMG;
  };

  useEffect(() => {
    const fetchArabicHouses = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'perfumes'));
        const housesMap = new Map();

        const allowed = new Set(Object.keys(arabicImages).map(normalize));

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const raw = String(data.designer || '').trim();
          if (!raw) return;

          const key = normalize(raw);
          if (!allowed.has(key) && !allowed.has(key.replace(/\s+/g, '-'))) return;

          if (!housesMap.has(key)) housesMap.set(key, { raw, key });
        });

        const list = Array.from(housesMap.values())
          .sort((a, b) => a.key.localeCompare(b.key, 'es'))
          .map((x) => x.raw);

        setArabicHouses(list);
      } catch (e) {
        console.error('Error fetching arabic houses:', e);
        setError('Error al cargar perfumes árabes.');
      } finally {
        setLoading(false);
      }
    };

    fetchArabicHouses();
  }, []);

  if (loading) return <Loader message="Cargando perfumes árabes..." />;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="arabic-grid-wrap">
      <div className="arabic-grid">
        {arabicHouses.map((designerRaw) => (
          <DesignerCard
            key={normalize(designerRaw)}
            designer={designerRaw}
            image={getLogo(designerRaw)}
            onClick={() => onSelectDesigner(designerRaw)}
          />
        ))}
      </div>
    </div>
  );
};

export default ArabicGrid;
